// GENERATED CODE -- DO NOT EDIT!
// To re-generate this file:
// start local dev server (w/ backend turned on)
// go run ./services/rewards/cmd/generate-translations
import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

import type {BadgeInfo} from "../badge-translations.ts";

export const getContextExerciseBadges: () => Record<string, BadgeInfo> =
    memoize(
        (): Record<string, BadgeInfo> => ({
            recoverybadge: {
                description: t`Persistence`,
                extendedDescription: t`Answer a problem correctly after having some trouble with a few problems and sticking with the skill`,
            },
            resurrectionbadge: {
                description: t`Sticktoitiveness`,
                extendedDescription: t`Answer a problem correctly after having some trouble with many problems and sticking with the skill`,
            },
            nicestreakbadge: {
                description: t`Nice Streak`,
                extendedDescription: t`Correctly answer 20 problems in a row in a single skill`,
            },
            greatstreakbadge: {
                description: t`Great Streak`,
                extendedDescription: t`Correctly answer 40 problems in a row in a single skill`,
            },
            awesomestreakbadge: {
                description: t`Awesome Streak`,
                extendedDescription: t`Correctly answer 60 problems in a row in a single skill`,
            },
            ridiculousstreakbadge: {
                description: t`Ridiculous Streak`,
                extendedDescription: t`Correctly answer 80 problems in a row in a single skill`,
            },
            ludicrousstreakbadge: {
                description: t`Ludicrous Streak`,
                extendedDescription: t`Correctly answer 100 problems in a row in a single skill`,
            },
            nicetimedproblembadge: {
                description: t`Picking Up Steam`,
                extendedDescription: t`Quickly & correctly answer 5 skill problems in a row (time limit depends on skill difficulty)`,
            },
            greattimedproblembadge: {
                description: t`Going Transonic`,
                extendedDescription: t`Quickly & correctly answer 10 skill problems in a row (time limit depends on skill difficulty)`,
            },
            awesometimedproblembadge: {
                description: t`Going Supersonic`,
                extendedDescription: t`Quickly & correctly answer 20 skill problems in a row (time limit depends on skill difficulty)`,
            },
            ridiculoustimedproblembadge: {
                description: t`Sub-light Speed`,
                extendedDescription: t`Quickly & correctly answer 42 skill problems in a row (time limit depends on skill difficulty)`,
            },
            ludicroustimedproblembadge: {
                description: t`299,792,458 Meters per Second`,
                extendedDescription: t`Quickly & correctly answer 75 skill problems in a row (time limit depends on skill difficulty)`,
            },
            soclosebadge: {
                description: t`Perseverance`,
                extendedDescription: t`Answer more than 30 problems mostly correctly in a skill before becoming proficient`,
            },
            keepfightingbadge: {
                description: t`Steadfastness`,
                extendedDescription: t`Answer more than 40 problems mostly correctly in a skill before becoming proficient`,
            },
            undeterrablebadge: {
                description: t`Tenacity`,
                extendedDescription: t`Answer more than 50 problems mostly correctly in a skill before becoming proficient`,
            },
        }),
    );
